import type { JSX } from 'react';

interface IconProps {
  size?: number;
  strokeWidth?: number;
}

function baseIconProps(size: number, strokeWidth: number): JSX.IntrinsicElements['svg'] {
  return {
    viewBox: '0 0 24 24',
    width: size,
    height: size,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
}

export function CloseIcon({ size = 20, strokeWidth = 2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

export function ArrowLeftIcon({ size = 15, strokeWidth = 2.2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export function ArrowRightIcon({ size = 15, strokeWidth = 2.2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

export function SmileIcon({ size = 20, strokeWidth = 2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  );
}

export function CommentIcon({ size = 20, strokeWidth = 2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

export function UserIcon({ size = 20, strokeWidth = 2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

export function StackIcon({ size = 20, strokeWidth = 2 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M12 2l10 6-10 6L2 8l10-6z" />
      <path d="M2 17l10 6 10-6" />
      <path d="M2 12l10 6 10-6" />
    </svg>
  );
}

export function CameraIcon({ size = 18, strokeWidth = 1.8 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

export function RecordIcon({ size = 18, strokeWidth = 1.8 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  );
}

export function PaperclipIcon({ size = 18, strokeWidth = 1.8 }: IconProps = {}): JSX.Element {
  return (
    <svg {...baseIconProps(size, strokeWidth)}>
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.41 17.41a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  );
}
